import { createReducer, on } from '@ngrx/store';
import * as AccountInfoActions from '../actions/account-info.actions';
import { RmdAgeInfo } from '../models/RmdAgeInfo';

export const rmdAgeInfoKey = 'rmdAgeInfo';

export interface State extends RmdAgeInfo { }

export const initialRmdAgeInfoState: State = {
  cusAge59Indicator: false,
  cusAge59On: '',
  cusAge70Indicator: false,
  cusAge70On: ''
};

export const rmdDateAgeReducer = createReducer(
  initialRmdAgeInfoState,
  on(AccountInfoActions.loadTransactionsSuccess, (state, response) => {
    return {
      ...state,
      cusAge59Indicator: response.rmdDetails?.cusAge59Indicator,
      cusAge59On: response.rmdDetails?.cusAge59On,
      cusAge70On: response.rmdDetails?.cusAge70On,
      cusAge70Indicator: response.rmdDetails?.cusAge70Indicator

    };
  }),
  on(AccountInfoActions.loadAccountInfoFailure, AccountInfoActions.loadAccountInfoServiceFailure, () => {
    return initialRmdAgeInfoState;
  })
);
